import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Get token from URL query params (from our own Google OAuth)
        const token = searchParams.get('token');
        const name = searchParams.get('name');
        const error = searchParams.get('error');

        if (error) {
          console.error('Auth error:', error);
          navigate('/login', { 
            state: { error: 'Google authentication failed. Please try again.' },
            replace: true 
          });
          return;
        }

        if (!token) {
          // Fallback: check for session_id in hash (old Emergent flow)
          const hash = location.hash;
          const params = new URLSearchParams(hash.replace('#', ''));
          const sessionId = params.get('session_id');

          if (!sessionId) {
            console.error('No token or session_id found in URL');
            navigate('/login');
            return;
          }
        }

        if (token) {
          // Store token in localStorage
          localStorage.setItem('auth_token', token);
          
          // Redirect to account page
          navigate('/account', { 
            replace: true 
          });
        }
      } catch (error) {
        console.error('Google auth error:', error);
        navigate('/login', { 
          state: { error: 'Google authentication failed. Please try again.' },
          replace: true 
        });
      }
    };

    processAuth();
  }, [navigate, location, searchParams]);

  return (
    <div className="min-h-screen bg-bg-main flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-accent mx-auto mb-4"></div>
        <p className="text-lg text-text-body font-body">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
